import { render, staticRenderFns } from "./pageCover.vue?vue&type=template&id=450f8cf0&scoped=true"
import script from "./pageCover.vue?vue&type=script&lang=js"
export * from "./pageCover.vue?vue&type=script&lang=js"
import style0 from "./pageCover.vue?vue&type=style&index=0&id=450f8cf0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450f8cf0",
  null
  
)

export default component.exports